import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'
import type { ComponentProps, FC } from 'react'
import { twMerge } from 'tailwind-merge'

const buttonStyles = cva(['flex', 'items-center', 'justify-center', 'transition-colors', 'font-semibold'], {
  variants: {
    variant: {
      default: ['bg-[#f5cb53]', 'hover:bg-[#ffd45d]'],
      hover: ['hover:bg-[#ffd45d]'],

      hoverBorder: ['hover:border-4', 'rounded-full', 'p-2', 'border-black'],
      border: [
        'border-4',
        'rounded-full',
        'p-2',
        'border-black',
        'hover:bg-gradient-to-br',
        'hover:from-indigo-500',
        'hover:via-purple-500',
        'hover:to-pink-500',
      ],
    },
    size: {
      default: ['rounded-lg', 'w-20', 'h-[35px]', 'p-2', 'text-sm'],
      button: ['rounded-lg', 'h-10', 'w-full'],
      icon: ['rounded-full', 'w-20', 'h-20', 'p-2.5'],
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
})

type ButtonProps = VariantProps<typeof buttonStyles> & ComponentProps<'button'>

export const Button: FC<ButtonProps> = (props) => {
  const { variant, size, className, type = 'button', ...otherProps } = props
  // eslint-disable-next-line react/button-has-type
  return <button type={type} className={twMerge(buttonStyles({ variant, size }), className)} {...otherProps} />
}
